import { render } from "./FollowOfficialAccount.vue?vue&type=template&id=aea4b87a&scoped=true&ts=true"
import script from "./FollowOfficialAccount.vue?vue&type=script&lang=ts"
export * from "./FollowOfficialAccount.vue?vue&type=script&lang=ts"

import "./FollowOfficialAccount.vue?vue&type=style&index=0&id=aea4b87a&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aea4b87a"]])

export default __exports__